import axios, { AxiosError } from "axios";
import { ROUTES_PATH } from "../constants";
import history from "../utils/history";
import {InsightService} from '@pepper/insights-react';

export const onResponseError = async (
  error: AxiosError<any, any>
): Promise<AxiosError> => {
  const config = error.config;
  InsightService.logException(error);
  let counter = 0;
  let maxRetries = 0;
  if (
    (error.response?.status === 500 &&
      !error.request.responseURL.includes("/reuse-payment")) ||
    (error.response?.status === 409 &&
      !error.request.responseURL.includes("/decisions"))
  ) {
    if (error.response?.status === 500) {
      maxRetries = 1;
    } else {
      maxRetries = 4;
    }
    while (counter < maxRetries) {
      try {
        counter++;
        const response = await axios.request(config!);
        return Promise.resolve(response.data.data);
      } catch (error) {
        if (counter === maxRetries) {
          history.replace(ROUTES_PATH.UNKNOWN_ERROR);
        }
      }
    }
  } else if (error.response?.status === 401) {
    history.replace(ROUTES_PATH.TIMEOUT);
  } else {
    const errorCode = error.response?.data.result.errors[0]?.code;
    switch (error.response?.status) {
      case 400:
        if (errorCode === "ESG0016") {
          history.replace(ROUTES_PATH.UNKNOWN_ERROR, { errorCode: errorCode });
        } else if (errorCode !== "ESG0014" && errorCode !== "ESG0015") {
          history.replace(ROUTES_PATH.UNKNOWN_ERROR);
        } else {
          history.replace(history.location.pathname, { errorCode: errorCode });
        }
        break;
      case 422:
        if (errorCode === "CRP0006") {
          history.replace(ROUTES_PATH.UNPROCESSABLE);
        } else {
          history.replace(history.location.pathname, { errorCode: errorCode });
        }
        break;
      case 500:
      case 409:
        break;
      default:
        history.replace(ROUTES_PATH.UNKNOWN_ERROR);
        break;
    }
  }
  return Promise.reject(error);
};
